import baseAPI from './api';
import baseURLs from '../configs/baseURLs';

class PrintServices{
    constructor (){
        this.api = baseAPI(baseURLs.API_PRINT);
    }

    async getObsKitchenPrint(get) {  

        const result = await this.api.post('imprimeCozinha', get);
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    async getPrintFinish(get) {  

        const result = await this.api.post('imprimirVenda', get);
        // pegando o retorno que vem no response
        
        return result.data;
        
    }
}

export default PrintServices